import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import axios from "axios";
import { NEWCPPREQUEST, CPPCODELIST, NOACCESS } from "../constants";

const PublicRoute = (props:any) => {

    if (props.isAuthenticated === null) return <p>Loading...</p>; 

    return props.isAuthenticated ? <Navigate to={props.isCPPCodeApprover ?  CPPCODELIST : (props.hassecgroup ? NEWCPPREQUEST : NOACCESS)} /> : <Outlet />;
};

export default PublicRoute;
